import axios from 'axios'

export const AnnouncementApi = {
    async Table(data){
        const response = await axios.post('/api/announcement/table',data)
        return response
    },
    async Detail(data){
        const response = await axios.get('/api/announcement/get/'+data)
        return response
    },
}